import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { buttonColor, onControlClick } from '../../JS/setColors'
import {
    setLightScene, sendCommand,
    VDAStatusApi, setMakeUPRoom,
    setDND
} from '../../action/roomControlAction'
import { popupOpenClose } from '../../action/action';
import { unlockDoor, makeUpRoomCall, doNotDisturbCall, zoneName } from '../../config/constant'
import { playDoorCameraStream } from '../../JS/playDoorCameraStream'

class DoorControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            doorLock: true,
            SessionToken: localStorage.getItem("GuestJourneySessionToken")
        }
    }
    componentDidMount() {
        buttonColor(this.props.menuColor);
        if (this.props.makeUpRoom && this.props.makeUpRoom === "ON") {
            document.getElementById("MakeUpRoomToggleButton").checked = true;
        }
        if (this.props.doNotDisturb && this.props.doNotDisturb === "ON") {
            document.getElementById("doNotDisturbToggleButton").checked = true;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.makeUpRoom !== prevProps.makeUpRoom) {
            if (this.props.makeUpRoom && this.props.makeUpRoom === "ON") {
                document.getElementById("MakeUpRoomToggleButton").checked = true;
            } else if (this.props.makeUpRoom && this.props.makeUpRoom === "OFF") {
                document.getElementById("MakeUpRoomToggleButton").checked = false;
            }
        }
        if (this.props.doNotDisturb !== prevProps.doNotDisturb) {
            if (this.props.doNotDisturb && this.props.doNotDisturb === "ON") {
                document.getElementById("doNotDisturbToggleButton").checked = true;
            } else if (this.props.doNotDisturb && this.props.doNotDisturb === "OFF") {
                document.getElementById("doNotDisturbToggleButton").checked = false;
            }
        }
    }

    VDAStatusCallBack = (status) => {
        if (status) {

        }
    }

    VDAApiCall = () => {
        //we have set this time out to make sure that we hit the status API after we hit the sendCommand
        window.setTimeout(() => {
            console.log("this.state.SessionToken", this.state.SessionToken);
            this.props.VDAStatusApi(
                this.state.SessionToken, this.props.guestDetail,
                this.VDAStatusCallBack, zoneName
            );
        }, 3000);
    }

    buttonClick = (id, mode) => {
        let lockTime = 5000
        onControlClick(id, mode, this.props.menuColor);
        let unlockToggleValue = document.getElementById("doorLockUnlockToggle").checked
        console.log("unlockToggleValue", unlockToggleValue, unlockToggleValue === true)
        if (id === "unlockFrontDoor" && unlockToggleValue === true) {
            this.props.setLightScene(
                "light20", unlockDoor, null,
                this.props.guestDetail, this.props.menuColor
            );
            if (this.props.doorLockTime) {
                lockTime = parseInt(this.props.doorLockTime);
            }
            console.log("lockTime", lockTime, this.props.doorLockTime)
            window.setTimeout(() => {
                document.getElementById("doorLockUnlockToggle").checked = false
            }, lockTime);
        } else {
            document.getElementById("doorLockUnlockToggle").checked = !unlockToggleValue
        }
    }

    makeUpMyRoomStatusChange = () => {
        let CheckedStatus = document.getElementById("MakeUpRoomToggleButton").checked
        let CDNDheckedStatus = document.getElementById("doNotDisturbToggleButton").checked
        if (this.props.makeUpRoom) {
            this.props.sendCommand(
                makeUpRoomCall, this.props.guestDetail,
                "MakeUpRoom", this.DNDandMakeUpcallBack, null,
                this.props.selectedZone.zone
            );
            if (CDNDheckedStatus) {
                document.getElementById("doNotDisturbToggleButton").checked = false
                this.props.setMakeUPRoom("OFF");
            }
            if (CheckedStatus) {
                this.props.setMakeUPRoom("ON");
            } else {
                this.props.setMakeUPRoom("OFF");
            }
            //this.VDAApiCall();
        } else {
            document.getElementById("MakeUpRoomToggleButton").checked = !CheckedStatus
        }
    }

    DNDStatusChange = () => {
        let CheckedStatus = document.getElementById("doNotDisturbToggleButton").checked
        let makeUpRoomCheckedStatus = document.getElementById("MakeUpRoomToggleButton").checked
        if (this.props.doNotDisturb) {
            this.props.sendCommand(
                doNotDisturbCall, this.props.guestDetail,
                "DND", this.DNDandMakeUpcallBack, null, "zone1"
            );
            if (makeUpRoomCheckedStatus) {
                document.getElementById("MakeUpRoomToggleButton").checked = false
                this.props.setMakeUPRoom("OFF");
            }
            if (CheckedStatus) {
                this.props.setDND("ON");
            } else {
                this.props.setDND("OFF");
            }
            //this.VDAApiCall();
        } else {
            document.getElementById("doNotDisturbToggleButton").checked = !CheckedStatus
        }
    }

    doorCameraView = (id, mode) => {
        let room = localStorage.getItem("room");
        if (room && room !== "null") {
            onControlClick(id, mode, this.props.menuColor);
            let videoUrl = this.props.streamingUrlFromConfig ?
                this.props.streamingUrlFromConfig :
                this.props.streamingUrlFromVDA ? this.props.streamingUrlFromVDA : null
            console.log("camera stream Urls=", "\n", "Url from Client config ==",
                this.props.streamingUrlFromConfig, "\n", "Url from VDA Api ==",
                this.props.streamingUrlFromVDA
            );
            if (videoUrl) {
                playDoorCameraStream(videoUrl, this.props);
            } else {
                console.log("this is what GJ getting as a video URL='", videoUrl, "'");
            }
        } else {
            this.props.popupOpenClose(true, "Not Connected to room.");
        }
    }

    DNDandMakeUpcallBack = (section, status) => {
        let CheckedStatus
        if (section === "DND") {
            if (!status) {
                CheckedStatus = document.getElementById("doNotDisturbToggleButton").checked
                document.getElementById("doNotDisturbToggleButton").checked = !CheckedStatus
            }
        } else if (section === "MakeUpRoom") {
            if (!status) {
                CheckedStatus = document.getElementById("MakeUpRoomToggleButton").checked
                document.getElementById("MakeUpRoomToggleButton").checked = !CheckedStatus
            }
        }
    }

    render() {
        return (
            <div id="controls-door" className="rc-controls w-100">
                <h2>Door controls</h2>
                <p style={{ color: "inherit" }}>
                    Take a look at who is at the door
                </p>
                <button id="openDoorCamera"
                    className="button w-100"
                    onClick={() => { this.doorCameraView("openDoorCamera", "door") }}>
                    <i className="fa fa-video-camera" style={{ color: "inherit", marginRight: "5px" }}></i>
                    Open door camera
                </button>
                {/* <button id="unlockFrontDoor"
                    className={this.state.doorLock ? "button w-100 " : "button selected w-100"}
                    onClick={() => { this.buttonClick("unlockFrontDoor", "door") }}>
                    <i className="fa fa-lock" style={{ color: "inherit" }}></i>
                    <span style={{ color: "inherit" }}>Unlock front door</span>
                </button> */}
                <div class="controls"
                    style={{
                        position: "relative", margin: "1rem 0", paddingTop: "1rem",
                        borderTop: "1px solid #999", height: "4rem", color: "inherit"
                    }}>
                    <p style={{
                        marginBottom: 0, marginRight: "1rem", color: "inherit",
                        marginTop: "0.75rem", display: "inline-block"
                    }}>
                        <strong style={{ color: "inherit" }}>Unlock front door</strong></p>
                    <label class="switch" style={{ position: "absolute", right: "1rem" }}>
                        <input id="doorLockUnlockToggle"
                            type="checkbox" class="use-all-toggle"
                            onClick={() => { this.buttonClick("unlockFrontDoor", "door") }}
                        />
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="controls"
                    style={{
                        position: "relative", margin: "1rem 0", paddingTop: "1rem",
                        borderTop: "1px solid #999", height: "4rem", color: "inherit"
                    }}>
                    <p style={{
                        marginBottom: 0, marginRight: "1rem", color: "inherit",
                        marginTop: "0.75rem", display: "inline-block"
                    }}>
                        <strong style={{ color: "inherit" }}>Do not disturb</strong>
                    </p>
                    <label class="switch" style={{ position: "absolute", right: "1rem" }}>
                        <input id="doNotDisturbToggleButton"
                            type="checkbox" class="use-all-toggle"
                            onClick={this.DNDStatusChange}
                        />
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="controls"
                    style={{
                        position: "relative", margin: "1rem 0", paddingTop: "1rem",
                        borderTop: "1px solid #999", height: "4rem", color: "inherit"
                    }}>
                    <p style={{
                        marginBottom: 0, marginRight: "1rem", color: "inherit",
                        marginTop: "0.75rem", display: "inline-block"
                    }}>
                        <strong style={{ color: "inherit" }}>Make up my room</strong></p>
                    <label class="switch" style={{ position: "absolute", right: "1rem" }}>
                        <input id="MakeUpRoomToggleButton"
                            type="checkbox" class="use-all-toggle"
                            onClick={this.makeUpMyRoomStatusChange}
                        />
                        <span class="slider round"></span>
                    </label>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        doNotDisturb: state.store.roomControl.VDAResponse.doNotDisturb ?
            state.store.roomControl.VDAResponse.doNotDisturb : null,
        makeUpRoom: state.store.roomControl.VDAResponse.makeUpRoom ?
            state.store.roomControl.VDAResponse.makeUpRoom : null,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        doorLockTime: state.store.home.clientConfig.extraConfigParam ?
            state.store.home.clientConfig.extraConfigParam.DOOR_UNLOCK_CONSECUTIVE_REQ_TIME_INTERVAL : null,
        streamingUrlFromVDA: state.store.roomControl.VDAResponse.doorCameraFeed ?
            state.store.roomControl.VDAResponse.doorCameraFeed.doorCameraFeedUrl : null,
        selectedZone: state.store.roomControl.selectedZone,
        VDAResponse: state.store.roomControl.VDAResponse
    }
}

export default connect(
    mapStateToProps,
    {
        setLightScene,
        sendCommand,
        VDAStatusApi,
        setMakeUPRoom,
        setDND,
        popupOpenClose
    }
)(DoorControl);
